module.exports = __webpack_public_path__ + "media/images/konintodoke/crown_2-45153895982ec6a012ea42040086ae0a.png";